import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { contextSelectorQueryKeys } from "./queryKeys";

/**
 * A base hook to fetch base context options from the API.
 *
 * Note: staleTime is set to Infinity to avoid refetching.
 */
export function useBaseContextOptions() {
  const client = useApi();

  return useQuery({
    queryKey: contextSelectorQueryKeys.all,
    queryFn: async () => {
      try {
        const response = await client.POST(
          "/v1/context-options/getContextOptions",
          {
            body: {
              fields: [],
              filters: {}
            }
          }
        );

        return response.data?.result ?? {};
      } catch (error) {
        console.error("Error fetching context options:", error);

        throw error; // Let TanStack Query handle the error state
      }
    },
    staleTime: Infinity
  });
}
